import { render, staticRenderFns } from "./FormRichText.vue?vue&type=template&id=288040d3&"
import script from "./FormRichText.vue?vue&type=script&lang=js&"
export * from "./FormRichText.vue?vue&type=script&lang=js&"
import style0 from "./FormRichText.vue?vue&type=style&index=0&id=288040d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports